import React from 'react'
import ToppingInfoButton from '../ToppingInfo'
import { ProductQuantity, Topping, ToppingMinus, ToppingName, ToppingPrice, ToppingTotal } from '../index.styled'
import ToppingBackButton from '../ToppingBack'
import Currency from '../../../../../currency'

const TouchPadContent = React.memo(({
	layout,
	subItem,
	subItemIndex,
	isCanceledSubItem,
	isPreparedToCancel,
	isCanceledItem,
	disabled,
	onClickToppingInfo,
	onClickToppingMinus,
	onClickBackTopping,
	infoAvailable
}) => {
	const cancelLayout =  ((isCanceledSubItem || isPreparedToCancel || isCanceledItem) ? ' strikethrough' : '')
	return (
		<>
			{(isCanceledSubItem || isPreparedToCancel) && !isCanceledItem && infoAvailable &&
				<ToppingInfoButton
					layout={layout}
					subItem={subItem}
					subItemIndex={subItemIndex}
					onClickToppingInfo={onClickToppingInfo}
				/>
			}
			<Topping
				className={layout + (subItem.quantity < 0 ? ' minus' : '') + cancelLayout +
					((isPreparedToCancel && !isCanceledItem) ? ' noRoundCorner' : '') +
					(isCanceledSubItem && infoAvailable ? ' noRoundCornerLeft' : '')}
				data-testid={subItem.name}
			>
				<ToppingName className={layout + (subItem.quantity < 0 ? ' minus' : '')}>
					{subItem.quantity > 0 ?
						<svg xmlns="http://www.w3.org/2000/svg" width="11.625" height="11.625" viewBox="0 0 11.625 11.625">
							<path d="M324.433,202.056l4.309-.018a0.754,0.754,0,0,0,.752-0.752,0.743,0.743,0,0,0-.747-0.748l-4.31.019,0.019-4.31a0.746,0.746,0,0,0-.748-0.748,0.756,0.756,0,0,0-.752.753l-0.019,4.309-4.309.019a0.754,0.754,0,0,0-.752.752,0.741,0.741,0,0,0,.747.747l4.31-.018-0.019,4.309a0.744,0.744,0,0,0,.748.748,0.754,0.754,0,0,0,.752-0.752Z" transform="translate(-317.875 -195.5)"></path>
						</svg> :
						<svg width="11" height="1" viewBox="0 0 11 1" xmlns="http://www.w3.org/2000/svg">
							<rect width="11" height="1" rx="0.5" />
						</svg>
					}
					{subItem.name}
					{(subItem?.quantity > 1 || subItem?.quantity < -1) &&
						<ProductQuantity className={layout}> x {Math.abs(subItem.quantity)}</ProductQuantity>
					}
				</ToppingName>

				{!disabled && <ToppingPrice className={layout + cancelLayout}><Currency>{subItem.price}</Currency></ToppingPrice>}
				<ToppingTotal className={layout + cancelLayout} />

				{(!disabled && !['CANCELED', 'PREPARED_TO_CANCEL'].includes(subItem.status) && !isCanceledItem) &&
					<ToppingMinus
						className={layout + (subItem.quantity < 0 ? ' minus' : '')}
						onClick={event => onClickToppingMinus(event, subItemIndex)}
						data-testid="btn-remove-topping"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.75 8.782" fill="#fff">
							<path id="btn-cross-white" d="M636.662,796.46l3.364-3.385a0.6,0.6,0,0,0,0-.838,0.587,0.587,0,0,0-.833,0l-3.364,3.385-3.365-3.385a0.586,0.586,0,0,0-.832,0,0.6,0.6,0,0,0,0,.838L635,796.46l-3.364,3.385a0.6,0.6,0,0,0,0,.838,0.587,0.587,0,0,0,.832,0l3.365-3.385,3.364,3.385a0.591,0.591,0,1,0,.833-0.838Z" transform="translate(-631.469 -792.062)" />
						</svg>
					</ToppingMinus>
				}
			</Topping>

			{isPreparedToCancel && !isCanceledItem &&
				<ToppingBackButton
					layout={layout}
					subItem={subItem}
					subItemIndex={subItemIndex}
					onClickBackTopping={onClickBackTopping}
				/>
			}
		</>
	)
})
export default TouchPadContent
TouchPadContent.displayName = 'TouchPadContent'
